/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getIntegrationChannels } from 'app/entities/integration-channel/integration-channel.reducer';
import { createEntity, getEntity, reset, updateEntity } from './integration-template.reducer';

export const IntegrationTemplateUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const integrationChannels = useAppSelector(state => state.integrationChannel.entities);
  const integrationTemplateEntity = useAppSelector(state => state.integrationTemplate.entity);
  const loading = useAppSelector(state => state.integrationTemplate.loading);
  const updating = useAppSelector(state => state.integrationTemplate.updating);
  const updateSuccess = useAppSelector(state => state.integrationTemplate.updateSuccess);

  const handleClose = () => {
    navigate(`/integration-template${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getIntegrationChannels({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...integrationTemplateEntity,
      ...values,
      channel: integrationChannels.find(it => it.id.toString() === values.channel?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...integrationTemplateEntity,
          channel: integrationTemplateEntity?.channel?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.integrationTemplate.home.createOrEditLabel" data-cy="IntegrationTemplateCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.integrationTemplate.home.createOrEditLabel">
              Create or edit a IntegrationTemplate
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="integration-template-id"
                  label={translate('tinyMedicRestApp.integrationTemplate.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationTemplate.name')}
                id="integration-template-name"
                name="name"
                data-cy="name"
                type="text"
              />
              <UncontrolledTooltip target="nameLabel">
                <Translate contentKey="tinyMedicRestApp.integrationTemplate.help.name" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationTemplate.code')}
                id="integration-template-code"
                name="code"
                data-cy="code"
                type="text"
              />
              <UncontrolledTooltip target="codeLabel">
                <Translate contentKey="tinyMedicRestApp.integrationTemplate.help.code" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationTemplate.description')}
                id="integration-template-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <UncontrolledTooltip target="descriptionLabel">
                <Translate contentKey="tinyMedicRestApp.integrationTemplate.help.description" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationTemplate.messageFormat')}
                id="integration-template-messageFormat"
                name="messageFormat"
                data-cy="messageFormat"
                type="text"
              />
              <UncontrolledTooltip target="messageFormatLabel">
                <Translate contentKey="tinyMedicRestApp.integrationTemplate.help.messageFormat" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationTemplate.active')}
                id="integration-template-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="activeLabel">
                <Translate contentKey="tinyMedicRestApp.integrationTemplate.help.active" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationTemplate.cursor')}
                id="integration-template-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <UncontrolledTooltip target="cursorLabel">
                <Translate contentKey="tinyMedicRestApp.integrationTemplate.help.cursor" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationTemplate.lastUpdated')}
                id="integration-template-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <UncontrolledTooltip target="lastUpdatedLabel">
                <Translate contentKey="tinyMedicRestApp.integrationTemplate.help.lastUpdated" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationTemplate.microSec')}
                id="integration-template-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <UncontrolledTooltip target="microSecLabel">
                <Translate contentKey="tinyMedicRestApp.integrationTemplate.help.microSec" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.integrationTemplate.timestampEntry')}
                id="integration-template-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <UncontrolledTooltip target="timestampEntryLabel">
                <Translate contentKey="tinyMedicRestApp.integrationTemplate.help.timestampEntry" />
              </UncontrolledTooltip>
              <ValidatedField
                id="integration-template-channel"
                name="channel"
                data-cy="channel"
                label={translate('tinyMedicRestApp.integrationTemplate.channel')}
                type="select"
              >
                <option value="" key="0" />
                {integrationChannels
                  ? integrationChannels.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/integration-template" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default IntegrationTemplateUpdate;
